/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useEffect, useContext } from "react";
import httpClient, { TimeoutError } from "../utils/httpClient";
import { UIContext } from "./UIProvider";
// import { JobProps } from "../types";
import {
  RegionProps,
  BonusProps,
  CompanyProps,
  CommunitiesProps,
  ProjectsProps,
} from "./types";

interface DataContextType {
  regions: RegionProps[];
  bonuses: BonusProps[];
  loadingBonuses: boolean;
  loadingCompanies: boolean;
  companies: CompanyProps[];
  communities: CommunitiesProps[];
  communities2: CommunitiesProps[];
  // jobs: JobProps[];
  // allJobs: JobProps[];
  selectedRegion: RegionProps | null;
  selectedCompany: CompanyProps | null;
  selectedCommunity: CommunitiesProps | null;
  // selectedJob: JobProps | null;
  projects: ProjectsProps[];
  role: string | null;
  setRole: React.Dispatch<React.SetStateAction<string | null>>;
  setSelectedRegion: React.Dispatch<React.SetStateAction<RegionProps | null>>;
  setSelectedCompany: React.Dispatch<React.SetStateAction<CompanyProps | null>>;
  setSelectedCommunity: React.Dispatch<
    React.SetStateAction<CommunitiesProps | null>
  >;
  // setSelectedJob: React.Dispatch<React.SetStateAction<JobProps | null>>;
  loadCommunities: () => void;
  loadProjects: () => void;
  updateSelectedRegion: (region: RegionProps) => void;
  loadDataForRole: (role: string) => void;
  // bonusType: string;
  // setBonusType: (type: string) => void;
}

const defaultState: DataContextType = {
  regions: [],
  bonuses: [],
  loadingBonuses: false,
  loadingCompanies: false,
  companies: [],
  communities: [],
  communities2: [],
  // jobs: [],
  // allJobs: [],
  projects: [],
  selectedRegion: null,
  selectedCompany: null,
  selectedCommunity: null,
  // selectedJob: null,
  role: null,
  setRole: () => {},
  setSelectedRegion: () => {},
  setSelectedCompany: () => {},
  setSelectedCommunity: () => {},
  loadCommunities: () => {},
  loadProjects: () => {},
  updateSelectedRegion: () => {},
  loadDataForRole: () => {},
  // bonusType: "ClosingBonus",
  // setBonusType: () => {},
};

const DataContext = createContext<DataContextType>(defaultState);

//@ts-ignore
export const DataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const getFromStorage = (key: string) => {
    const storedData = localStorage.getItem(key);
    return storedData ? JSON.parse(storedData) : [];
  };

  const getFromStorage2 = (key: string) => {
    const storedData = localStorage.getItem(key);
    return storedData ? JSON.parse(storedData) : null;
  };

  const getFromStorage3 = (key: string) => {
    const storedData = localStorage.getItem(key);
    return storedData || null;
  };
  const [state, dispatch]: any = useContext(UIContext);
  const [bonuses, setBonuses] = useState<BonusProps[]>([]);
  const [loadingBonuses, setLoadingBonuses] = useState<boolean>(false);
  const [loadingCompanies, setLoadingCompanies] = useState<boolean>(false);
  const [role, setRole] = useState<string | null>(getFromStorage3("role"));
  const [regions, setRegions] = useState(getFromStorage("regions"));
  const [companies, setCompanies] = useState<CompanyProps[]>([]);
  const [allCompanies, setAllCompanies] = useState<CompanyProps[]>(
    getFromStorage("companies")
  );
  const [communities, setCommunities] = useState<CommunitiesProps[]>([]);
  const [communities2, setCommunities2] = useState<CommunitiesProps[]>([]);
  // const [jobs, setJobs] = useState<JobProps[]>([]);
  // const [allJobs, setAllJobs] = useState<JobProps[]>(getFromStorage("allJobs"));
  const [projects, setProjects] = useState<ProjectsProps[]>([]);
  const [bonusType, setBonusType] = useState<string>(
    localStorage.getItem("bonusType") || "ClosingBonus"
  );

  const [selectedRegion, setSelectedRegion] = useState<RegionProps | null>(
    getFromStorage2("selectedRegion")
  );
  const [selectedCompany, setSelectedCompany] = useState<CompanyProps | null>(
    getFromStorage2("selectedCompany")
  );
  const [selectedCommunity, setSelectedCommunity] =
    useState<CommunitiesProps | null>(getFromStorage("selectedCommunity"));
  // const [selectedJob, setSelectedJob] = useState<JobProps | null>(null);

  function findCompanyByRegion(
    companies: CompanyProps[],
    regionId: number
  ): CompanyProps | undefined {
    // Iterate through each company in the array
    for (let company of companies) {
      // Split the regionIds string into an array of strings
      let regions = company.regionIds.split(", ");

      // Check if the regionId exists in the split array
      if (regions.includes(regionId.toString())) {
        return company;
      }
    }

    // Return undefined if no company is found with the given regionId
    return undefined;
  }

  const updateSelectedRegion = async (region: RegionProps) => {
    if (allCompanies) {
      const company = findCompanyByRegion(
        allCompanies,
        region.regionId as number
      );
      setSelectedCompany(company as CompanyProps);
      localStorage.setItem("selectedCompany", JSON.stringify(company));
      setSelectedRegion(region);
      localStorage.setItem("selectedRegion", JSON.stringify(region));

      // Reload relevant data
      await loadCommunities();
      await loadProjects();
    }
  };

  const loadCommunities = async () => {
    if (localStorage.getItem("communities")) {
      const allJ = JSON.parse(localStorage.getItem("communities") as any);
      setCommunities(
        allJ.sort((a: { subDivision: string }, b: { subDivision: any }) =>
          a.subDivision.localeCompare(b.subDivision)
        )
      );
      setCommunities2(
        allJ
          .reduce(
            (acc: any[], current: { projectId: any; subDivision: string }) => {
              if (!acc.find((item) => item.projectId === current.projectId)) {
                acc.push(current);
              }
              return acc;
            },
            []
          )
          .sort((a: { subDivision: string }, b: { subDivision: any }) =>
            a.subDivision.localeCompare(b.subDivision)
          )
      );
    }

    if (selectedCompany && selectedRegion) {
      try {
        const res = await httpClient.get<CommunitiesProps[]>(
          `/api/cba/communities-summary/${selectedCompany.companyId}/${selectedRegion.regionId}`
        );
        if (res.data.length <= 0) {
          dispatch({
            type: "Snackbar",
            payload: {
              show: true,
              message: "There are no communities available in this region",
              severity: "error",
            },
          });
        }
        setCommunities(res.data);
        setCommunities2(
          res.data
            .reduce(
              (
                acc: any[],
                current: { projectId: any; subDivision: string }
              ) => {
                if (!acc.find((item) => item.projectId === current.projectId)) {
                  acc.push(current);
                }
                return acc;
              },
              []
            )
            .sort((a: { subDivision: string }, b: { subDivision: any }) =>
              a.subDivision.localeCompare(b.subDivision)
            )
        );
        localStorage.setItem("communities", JSON.stringify(res.data));
      } catch (error) {
        console.error(error);
      }
    }
  };

  const loadProjects = async () => {
    if (localStorage.getItem("projects")) {
      const p = JSON.parse(localStorage.getItem("projects") as any);
      setProjects(p);
    }
    const [projectsRes] = await Promise.all([
      httpClient.get("/api/cba/projects"),
    ]);
    const projectsData = projectsRes.data.sort(
      (a: { subdivision: string }, b: { subdivision: any }) =>
        a.subdivision.localeCompare(b.subdivision)
    );

    setProjects(projectsData);
    localStorage.setItem("projects", JSON.stringify(projectsData));
  };

  const loadDataForRole = (role: string) => {
    setRole(role);
    localStorage.setItem("role", role);

    // Reload relevant data
    loadCommunities();
    loadProjects();
  };

  // useEffect(() => {
  //   if (selectedCompany && selectedRegion) {
  //     loadCompanies();
  //   }
  // }, [selectedRegion, selectedCompany]);

  useEffect(() => {
    if (role) {
      loadDataForRole(role);
    }
  }, [role]);

  // const handleBonusTypeChange = (type: string) => {
  //   setBonusType(type);
  //   localStorage.setItem("bonusType", type);
  // };

  return (
    <DataContext.Provider
      value={{
        regions,
        bonuses,
        loadingBonuses,
        loadingCompanies,
        companies,
        communities,
        communities2,
        // jobs,
        // allJobs,
        selectedRegion,
        selectedCompany,
        selectedCommunity,
        // selectedJob,
        role,
        projects,
        setRole,
        setSelectedRegion,
        setSelectedCompany,
        setSelectedCommunity,
        
        loadCommunities,
        loadProjects,
        updateSelectedRegion, 
        loadDataForRole, 
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
